module.exports = __webpack_public_path__ + "img/spring_printed_dress-400x520.88c6b738.jpg";